/**
 * Plugin Vue para funcionalidades do template NiceShop
 * Registra o mixin globalmente para uso em todos os componentes
 */

import templateMixin from '../mixins/templateMixin'

export default {
  install(Vue) {
    // Registra o mixin globalmente
    Vue.mixin(templateMixin)
    
    // Adiciona métodos globais ao Vue
    Vue.prototype.$initTemplateFeatures = function() {
      this.initAllTemplateFeatures()
    }
    
    Vue.prototype.$initAOS = function() {
      this.initAOS()
    }
    
    Vue.prototype.$initGLightbox = function() {
      this.initGLightbox()
    }
    
    Vue.prototype.$initSwiper = function() {
      this.initSwiper()
    }
    
    Vue.prototype.$initDrift = function() {
      this.initDrift()
    }
    
    Vue.prototype.$initMobileNav = function() {
      this.initMobileNav()
    }
    
    Vue.prototype.$initScrollTop = function() {
      this.initScrollTop()
    }
    
    Vue.prototype.$initFAQ = function() {
      this.initFAQ()
    }
    
    Vue.prototype.$initCountdown = function() {
      this.initCountdown()
    }
  }
}
